
import * as PatientsActions from '../actions/patients-actions.ts';

module.exports = class PatientsService {

  static $inject = [
    '$http',
    '$ngRedux',
    '$q',
    'Patients',
    'Subscriptions',
  ];

  constructor(
    $http,
    $ngRedux,
    $q,
    Patients,
    Subscriptions,
  ) {
    this.$http = $http;
    this.$ngRedux = $ngRedux;
    this.$q = $q;
    this.Patients = Patients;
    this.Subscriptions = Subscriptions;
  }

  territories() {
    return this.$http.get('/api/v2/account/territories');
  }

  loadPatient(patientId, includeChildren = true) {
    const groupId = this.$ngRedux.getState().group.id;

    return this.Patients.get({ patient_id: patientId, group_id: groupId }).$promise.then((patient) => {
      const children = patient.children.map(child => child.id);

      if (includeChildren && children.length) {
        const promises = [];

        _.each(children, (childId, index) => {
          promises.push(this.loadPatient(childId, false).then((child) => {
            patient.children[index] = child;
          }));
        });

        return this.$q.all(promises).then(() => {
          this.$ngRedux.dispatch(PatientsActions.setPatient(patient));

          return patient;
        });
      }
      this.$ngRedux.dispatch(PatientsActions.setPatient(patient));

      return patient;
    });
  }

  patch(patientId, groupId, operations) {
    return this.$http.patch(`/api/v2/patients/${patientId}`, { operations, groupId });
  }

  confirmPasswordChange(patientId, groupId, state, callback) {
    return this.patch(patientId, groupId, [{ op: 'replace', path: '/confirm_password', value: true }])
    .then(callback);
  }

  changeLocale(patientId, groupId, locale, callback) {
    return this.patch(patientId, groupId, [{ op: 'replace', path: '/locale', value: locale }])
    .then(callback);
  }

  replaceAgreement(patientId, groupId, callback) {
    return this.patch(patientId, groupId, [{ op: 'replace', path: '/patient_agreement', value: '' }])
    .then(callback);
  }

  checkChangeAvailability() {
    return this.$http.get('/api/v2/patients/authenticated');
  }

  changePassword(patientId, data) {
    return this.$http.put(`/api/v2/patients/${patientId}/password`, {
      password: data.password,
      new_password: data.newPassword,
      confirm_new_password: data.confirmNewPassword,
    });
  }

  changeEmail(patientId, groupId, email) {
    return this.$http.patch(`/api/v2/patients/${patientId}`, {
      operations: [
        {
          op: 'replace',
          path: '/unconfirmed_email',
          value: email,
        },
      ],
      groupId,
    });
  }

  updateAddress(patient) {
    return this.$http.put(`/api/v2/patients/${patient.id}/profile`, {
      id: patient.id,
      group_id: patient.groupId,
      civic_address: patient.profile.street,
      city: patient.profile.city,
      postal_code: patient.profile.postalCode,
      territory: patient.profile.province,
    });
  }

  updateContactMethods(patientId, groupId, contactMethods) {
    return this.$http.put(`/api/v2/patients/${patientId}/contact_methods`, {
      id: patientId,
      group_id: groupId,
      contact_methods: contactMethods,
    });
  }

  updateMedicalInfos(patient) {
    return this.$http.put(`/api/v2/patients/${patient.id}/profile`, {
      id: patient.id,
      group_id: patient.groupId,
      civic_address: patient.profile.street,
      city: patient.profile.city,
      postal_code: patient.profile.postalCode,
      territory: patient.profile.province,
      known_illnesses: patient.profile.knownIllnesses,
      known_allergies: patient.profile.knownAllergies,
    });
  }

  unlinkPatient(parentId, params, callback) {
    return this.$http.delete(`/api/v2/patients/${parentId}/linked_patients`, {
      params,
    }).then(response => callback(response));
  }
};



// WEBPACK FOOTER //
// ./main/services/patients-service.js